import Image from "../img/img2.png";
import Imagemobile from "../img/img2-mobile.png";
// Imagens SVG dos serviços (iguais ao Service.js)
import ImgConjugal from "../img/team/conjugal.svg";
import ImgFilhos from "../img/team/filhos.svg";
import ImgEmpresarial from "../img/team/empresarial.svg";
import ImgIdoso from "../img/team/cuidador.svg";
import Home from "../img/home.png";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Utilidade from "../context/Unidades";
import { useHistory, useParams } from "react-router";
import handleMaskTel from "../context/HandleMask";
import Medalha from "../img/app/medalha.webp";

// CSS para animação dos cards e efeito hover

export default function Welcome() {
  // Garante que params nunca é undefined
  const history = useHistory();
  const { uf } = useParams();

  const [brand, setBrand] = useState({});

  useEffect(() => {
    setBrand(Utilidade.renderRegiao(uf));
  }, []);

  if (uf === undefined) {
    history.push("/#ge");
    window.location.reload();
  }

  return (
    <>
      <div
        className="container-private"
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="row"
          style={{ width: "100%", height: "100%", background: "#fff" }}
        >
          {/* Coluna Esquerda - Imagem ocupa toda a coluna */}
          <div
            className="col-xl-6 col-lg-6 col-md-6 d-flex p-0 welcome-hide-mobile"
            style={{
              height: "100%",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <img
              src={Image}
              alt="Ilustração"
              style={{ height: "100%", width: "100%", objectFit:"contain" }}
            />
          </div>
          {/* Coluna Direita */}
          <div className="col-xl-6 col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center welcome-content-mobile">
            <Link
              className="navbar-brand p-0 "
              to={`${process.env.PUBLIC_URL + "/" + uf}`}
            >
              <img
                src={brand.logo}
                alt="logo"
                class="logo-main"
                style={{
                  marginBottom: 40,
                  marginTop: 10,
                  width: 250,
                  height: 80,
                }}
              />
            </Link>
            <h1>Bem-vindo ao nosso site!</h1>
   
            <p>Explore nossos serviços: </p>

            {uf == "sp" ? (
              <img src={Medalha} alt="img" className="medalha medalhaWelcome" />
            ) : null}

            <img
              src={Imagemobile}
              alt="Ilustração"
              className="welcome-img-mobile"
              style={{
                display: "none",
                width: "100%",
                maxWidth: 240,
                height: 200,
                objectFit: "cover",
              }}
            />
            <div >
              <div className="welcome-cards-grid">
                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/home`}
                  className="welcome-card welcome-card-anim delay-1"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={Home} alt="Home" />
                  <div className="welcome-card-content">
                    <h4>Home</h4>
                  </div>
                </Link>

                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/investigacao_conjugal`}
                  className="welcome-card welcome-card-anim delay-1"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={ImgConjugal} alt="Conjugal" />
                  <div className="welcome-card-content">
                    <h4>Investigação Conjugal</h4>
                  </div>
                </Link>

                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/investigacao_filhos`}
                  className="welcome-card welcome-card-anim delay-2"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={ImgFilhos} alt="Filhos" />
                  <div className="welcome-card-content">
                    <h4>Investigação de Filhos</h4>
                  </div>
                </Link>

                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/investigacao_empresarial`}
                  className="welcome-card welcome-card-anim delay-3"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img src={ImgEmpresarial} alt="Empresarial" />
                  <div className="welcome-card-content">
                    <h4>Investigação Empresarial</h4>
                  </div>
                </Link>

                {/* Card: Encontrar Pessoas */}
                <Link
                  to={`${process.env.PUBLIC_URL}/${uf}/localizacao_pessoas`}
                  className="welcome-card welcome-card-anim delay-4"
                  tabIndex={0}
                  style={{ textDecoration: "none" }}
                >
                  <img
                    src={require("../img/team/localizacao.svg").default}
                    alt="Encontrar Pessoas"
                  />
                  <div className="welcome-card-content">
                    <h4>Encontrar Pessoas</h4>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
